import React from 'react';

const TERMS_TEXT = `Last updated: July 2026 — PLACEHOLDER, NOT YET REVIEWED BY LEGAL COUNSEL

1. Acceptance of Terms
By creating an account, you agree to these Terms of Service. This is a placeholder
document and will be replaced with a formal, attorney-reviewed version before this
service is made available to the general public.

2. What This Service Does
Boring Budgeting connects to your financial accounts via Plaid to display and
categorize your transactions, help you track a household budget, and let you
manually record planned or off-platform expenses.

3. No Financial Advice
Nothing in this application constitutes financial, tax, legal, or investment
advice. Budget suggestions, tax estimates, and net worth calculations are
estimates only and should not be relied upon for financial decisions.

4. Your Data
Your financial data is stored on infrastructure operated by the site owner.
While reasonable security measures are used, no system is completely secure.
You use this service at your own risk.

5. Limitation of Liability
To the fullest extent permitted by law, the operator of this service is not
liable for any damages, losses, or unauthorized access to your data arising
from use of this service, including but not limited to data breaches, service
interruptions, or inaccuracies in displayed financial information.

6. Account Termination
The operator reserves the right to suspend or terminate accounts at any time.

7. Changes to These Terms
These terms may change at any time. Continued use of the service after changes
constitutes acceptance of the revised terms.

--
This document is a placeholder pending review by a licensed attorney and does
not constitute a legally binding agreement in its current form.`;

const PRIVACY_TEXT = `Last updated: July 2026 — PLACEHOLDER, NOT YET REVIEWED BY LEGAL COUNSEL

1. What We Collect
Account information you provide (name, email), financial account and
transaction data via Plaid, and any information you manually enter (planned
expenses, income, notes).

2. How We Use It
Solely to provide the budgeting features of this application - categorizing
transactions, calculating budgets, and displaying your financial picture back
to you. We do not sell your data.

3. Third Parties
We use Plaid, Inc. to connect to your financial institutions. Plaid's own
privacy policy governs their handling of your data during that connection.
We do not share your financial data with advertisers or other third parties.

4. Data Storage
Your data is stored in a private database. Passwords are hashed and never
stored in plain text. Bank access tokens are encrypted at rest.

5. Data Retention
Your data is retained as long as your account is active. You may request
deletion of your account and associated data at any time.

6. Security
We use industry-standard practices including encrypted connections (HTTPS),
password hashing, and encrypted storage of sensitive tokens. No system is
completely secure, and we cannot guarantee absolute protection against
unauthorized access.

7. Changes to This Policy
This policy may change at any time. Continued use of the service after
changes constitutes acceptance of the revised policy.

--
This document is a placeholder pending review by a licensed attorney and does
not constitute a legally binding privacy commitment in its current form.`;

export default function LegalModal({ doc, onClose }) {
  const text = doc === 'privacy' ? PRIVACY_TEXT : TERMS_TEXT;
  const title = doc === 'privacy' ? 'Privacy Policy' : 'Terms of Service';

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div style={styles.header}>
          <h2 style={styles.title}>{title}</h2>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <div style={styles.badge}>⚠ Placeholder — pending legal review</div>
        <pre style={styles.body}>{text}</pre>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '1rem',
  },
  modal: {
    background: '#111827',
    border: '1px solid #1e2a3a',
    borderRadius: '16px',
    maxWidth: '600px',
    width: '100%',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '0.5rem',
  },
  title: {
    margin: 0,
    fontSize: '1.1rem',
    fontWeight: '700',
    color: '#fff',
    fontFamily: "'Syne', sans-serif",
  },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    color: '#6b7280',
    fontSize: '1rem',
    cursor: 'pointer',
  },
  badge: {
    background: 'rgba(251, 191, 36, 0.1)',
    color: '#fbbf24',
    border: '1px solid #fbbf24',
    borderRadius: '6px',
    padding: '6px 10px',
    fontSize: '0.75rem',
    fontWeight: '600',
    marginBottom: '1rem',
    fontFamily: "'Syne', sans-serif",
    display: 'inline-block',
  },
  body: {
    color: '#9ca3af',
    fontSize: '0.8rem',
    lineHeight: '1.6',
    whiteSpace: 'pre-wrap',
    fontFamily: "'DM Mono', monospace",
    overflowY: 'auto',
    margin: 0,
  },
};
